import { useEffect, useState } from "react";
import { Save } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

const GROUP_LABELS = {
  brand: "Marque", hero: "Hero & recherche", ambition: "Ambition",
  human: "Dimension humaine", process: "Méthode (étapes)", contact: "Contact",
};

export default function SettingsAdmin() {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);

  const load = () => { setLoading(true); api.get("/admin/settings").then(({ data }) => setSettings(data)).catch(() => {}).finally(() => setLoading(false)); };
  useEffect(() => { load(); }, []);

  const updateField = (group, key, value) => setSettings((s) => ({ ...s, [group]: { ...s[group], [key]: value } }));

  const saveGroup = async (group) => {
    await api.put(`/admin/settings/${group}`, { value: settings[group] });
    toast.success(`« ${GROUP_LABELS[group] || group} » enregistré`);
  };

  const inputCls = "w-full border border-tertiary bg-white px-3 py-2 text-sm outline-none focus:border-champagne focus:ring-1 focus:ring-champagne";

  if (loading) return <p className="text-anthracite/40">…</p>;

  return (
    <div className="max-w-3xl">
      <h1 className="mb-1 font-serif text-3xl text-anthracite">Paramètres du site</h1>
      <p className="mb-8 text-sm text-anthracite/50">Contenus éditables affichés sur le site public (FR/EN).</p>

      <div className="space-y-6">
        {Object.entries(settings).map(([group, value]) => (
          <div key={group} data-testid={`settings-${group}`} className="border border-tertiary bg-white p-6">
            <div className="mb-4 flex items-center justify-between">
              <h2 className="font-serif text-xl text-anthracite">{GROUP_LABELS[group] || group}</h2>
              <button onClick={() => saveGroup(group)} data-testid={`save-${group}`} className="inline-flex items-center gap-2 bg-anthracite px-4 py-2 text-xs font-medium text-ivory hover:bg-black"><Save className="h-3.5 w-3.5" /> Enregistrer</button>
            </div>
            <div className="grid gap-4 sm:grid-cols-2">
              {value && typeof value === "object" && Object.entries(value).map(([k, v]) => (
                <div key={k} className={typeof v === "string" && v.length > 60 ? "sm:col-span-2" : ""}>
                  <label className="mb-1 block text-xs uppercase tracking-[0.12em] text-anthracite/50">{k}</label>
                  {Array.isArray(v) ? (
                    <input value={v.join(", ")} onChange={(e) => updateField(group, k, e.target.value.split(",").map((x) => x.trim()).filter(Boolean))} className={inputCls} />
                  ) : typeof v === "string" && v.length > 60 ? (
                    <textarea rows={2} value={v} onChange={(e) => updateField(group, k, e.target.value)} className={inputCls} />
                  ) : (
                    <input value={v ?? ""} onChange={(e) => updateField(group, k, e.target.value)} className={inputCls} />
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
